<template>
  <v-card flat class="pa-4" color="transparent">
    <v-row justify="center" class="ma-0">
      <v-card flat color="transparent" width="100%">
        <v-row class="ma-0" align="center">
          <v-col  v-if="reviewDetails.TotalNrOfReviews > 0">
            <v-row align="center">
              <h2>
                {{ reviewDetails.AverageRating }}
              </h2>
              <v-rating
                v-model="reviewDetails.AverageRating"
                readonly
                half-increments
                color="yellow darken-3"
                background-color="yellow darken-3"
                empty-icon="star_outline"
                full-icon="star"
                half-icon="star_half"
                large
              ></v-rating>
              <span class="text--disabled text-body-1">
                {{ reviewDetails.TotalNrOfReviews }} {{ $translate('REVIEWS') }}
              </span>
            </v-row>
          </v-col>

          <!-- Reviews -->
          <v-btn
            v-if="userLoggedIn"
            class="primary-font-color text-capitalize ml-auto"
            color="primary"
            @click="reviewDialog = true"
          >
            <v-icon class="pa-2">rate_review</v-icon>
            {{ $translate('LEAVE_A_REVIEW') }}</v-btn
          >
        </v-row>
      </v-card>
    </v-row>

    <v-timeline dense align-top
    v-if="reviewDetails.TotalNrOfReviews > 0">
      <v-timeline-item
        v-for="(item, index) in allReviews"
        :key="index"
        :color="getColorForTimeLineBall(item.Rating)"
        small
      >
        <v-card class="elevation-2">
          <v-row class="ma-0">
            <v-col cols="12" md="9">
              <v-card-title class="ml-4 pa-0">{{ item.Name }}</v-card-title>
              <v-card-text v-html="item.Review" class="pb-0"> </v-card-text>
            </v-col>
            <v-col cols="12" md="3">
              <v-rating
                readonly
                color="yellow darken-3"
                background-color="yellow darken-3"
                v-model="item.Rating"
                empty-icon="star_outline"
                full-icon="star"
                half-icon="star_half"
                small
              />
              <div class="text--disabled text-caption px-3">
                {{ item.DateStr }} - {{ item.TimeStr }}
              </div>
            </v-col>
          </v-row>
          <v-col
            v-if="item.Response.DateStr !== ''"
            class="responseBlock"
            cols="12"
          >
            <v-row>
              <v-col
                class="pa-0 d-flex justify-center align-start"
                cols="2"
                sm="1"
              >
                <v-icon size="4vh">subdirectory_arrow_right</v-icon>
              </v-col>
              <v-col class="pa-0 pl-2 pl-sm-0" cols="10" sm="11">
                <v-row justify="space-between">
                  <v-col justify="start" class="pa-0" cols="11" md="9">
                    <v-card-title class="pa-0">{{
                      item.Response.Name
                    }}</v-card-title>
                    <div class="pNoMargin" v-html="item.Response.Response" />
                  </v-col>
                  <v-col class="pa-sm-0" cols="11" md="3">
                    <v-row justify="start" justify-md="end">
                      <p
                        class="pNoMargin"
                        style="text-align: end; margin-right: 2em !important"
                      >
                        {{ item.Response.DateStr }} -
                        {{ item.Response.TimeStr }}
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-timeline-item>
    </v-timeline>

    <v-col cols="12" style="margin-bottom: 6em">
      <v-row justify="center" align="center">
        <v-btn
          rounded
          :disabled="disableLoadMore"
          @click="getReviews()"
          color="primary"
          >{{ $translate('LOAD_MORE') }}</v-btn
        >
      </v-row>
    </v-col>

    <v-dialog v-model="reviewDialog" width="500">
      <v-card
        v-if="
          $store.getters['auth/user'] &&
          $store.getters['auth/user'].firstName === ''
        "
        class="d-inline-block mx-auto full-width"
      >
        <v-card-title style="word-break: normal">
          {{ $translate('LEAVE_A_REVIEW') }}
        </v-card-title>
        <v-container class="no-scroll pl-5 pr-5">
          <v-row class="pl-5" align="center">
            <p>{{ $translate('REVIEW_ONLY_WITH_NAME') }}</p>
          </v-row>
          <v-row class="pl-5" align="center">
            <p>{{ $translate('CLICK_TO_SET_NAME') }}</p>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue"
              class="mt-3 text-capitalize"
              text
              @click="goToAccount"
            >
              {{ $translate('GO_TO_ACCOUNT') }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
      <v-card v-else class="d-inline-block mx-auto full-width">
        <v-card-title style="word-break: normal">
          {{ $translate('LEAVE_A_REVIEW') }}
        </v-card-title>
        <v-container class="no-scroll pl-5 pr-5">
          <v-row class="pl-5" align="center">
            <v-rating
              v-model="rating"
              full-icon="star"
              empty-icon="star_outline"
              background-color="grey"
              color="orange"
              medium
              required
              class="mb-2 mt-2"
            />
            <p class="error-text mt-4 ml-2" v-if="reviewError">
              {{ $translate('PICK_A_RATING') }}
            </p>
          </v-row>
          <v-row justify="space-between" class="pl-5 pr-5">
            <v-textarea
              outlined
              name="input-7-4"
              :label="$translate('REVIEW')"
              v-model="review"
            />
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue"
            class="mt-3 text-capitalize"
            text
            @click="addReview"
          >
            {{ $translate('SUBMIT') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import doRequest from '@/api/dssRequest';

export default {
  name: 'EventDetailsReviews',
  data() {
    return {
      reviewDialog: false,
      reviewDetails: {},
      disableLoadMore: false,
      listOfResponses: [],
      allReviews: [],
      review: '',
      reviewError: false,
      rating: 0,
    };
  },
  props: {
    eventDetails: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters['auth/userName'];
    },
  },
  mounted() {
    setTimeout(() => {
      this.getReviews();
    }, 1000);
  },
  methods: {
    addReview() {
      if (this.rating === 0) {
        this.reviewError = true;
      } else {
        this.reviewError = false;
        const payload = {
          Name: `${this.$store.getters['auth/user'].firstName}`,
          Rating: this.rating,
          Review: this.review,
        };
        doRequest(
          () => {
            this.reviewDialog = false;
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('REVIEW_SUCCESS')
            );
            this.allReviews = [];
            this.getReviews();
          },
          () => {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('REVIEW_FAIL')
            );
          },
          'addReview',
          this.eventDetails.EventId,
          payload,
          'POST',
          600000,
          false
        );
      }
    },

    goToAccount() {
      this.reviewDialog = false;
      this.$router.push({
        name: 'UserSettings',
        params: {
          userSettings: true,
        },
      });
    },
    getReviews() {
      this.disableLoadMore = true;
      const payload = {
        From: this.allReviews.length,
        Until: this.allReviews.length + 10,
      };
      doRequest(
        (response) => {
          response.data.Reviews.forEach((review) => {
            review.Review = review.Review.replace(/\n/g, '<br>');
            review.Response.Response = review.Response.Response.replace(
              /\n/g,
              '<br>'
            );

            this.allReviews.push(review);
          });

          this.reviewDetails = response.data;
          this.reviewDetails.AverageRating = Number(
            this.reviewDetails.AverageRating.toFixed(1)
          );
          if (Object.values(response.data.Reviews).length === 10) {
            this.disableLoadMore = false;
          }
        },
        () => {},
        'getReviews',
        this.eventDetails.EventId,
        payload,
        'GET'
      );
    },
    getColorForTimeLineBall(totalRating) {
      switch (totalRating) {
        case 1:
          return '#FF0000';
        case 2:
          return '#FF7B00';
        case 3:
          return '#FFFF00';
        case 4:
          return '#B0FF00';
        case 5:
          return '#00FF00';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.responseBlock {
  background-color: lightgrey;
}
.pNoMargin {
  margin-bottom: 0 !important;
}
</style>
